// extracted by mini-css-extract-plugin
export default {"container":"Input_container__QYQCc","input":"Input_input__4Gyv4","label":"Input_label__Uio3h"};